module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iseditor) ? _c('div', {
    staticClass: "baseplugin",
    staticStyle: {
      "width": "calc(100% + 10px)"
    }
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true
      }),
      expression: "{preventParentScroll: true}"
    }],
    style: ({
      height: (_vm.height + "px")
    })
  }, [_c('div', [_c('draggable', {
    staticClass: "baseplugin-ul",
    attrs: {
      "options": {
        group: {
          name: 'sort1',
          pull: 'clone',
          put: false
        },
        draggable: '.plugin-li',
        sort: false,
        ghostClass: 'sortghost'
      }
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    }
  }, [_c('div', {
    staticClass: "plugin-li",
    staticStyle: {
      "border": "0",
      "width": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.plugins), function(plugin, idx) {
    return _c('div', {
      key: idx,
      staticClass: "plugin-li",
      attrs: {
        "data-role": plugin.name
      }
    }, [_c('i', {
      class: plugin.icon
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(plugin.alias))])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "height": "0",
      "overflow": "hidden"
    }
  })], 2)], 1)]), _vm._v(" "), (_vm.pluginTipsShow) ? _c('div', {
    staticClass: "tip-left"
  }, [_vm._v("\n\t\t按住鼠标左键拖动插件到页面\n\t\t"), _c('span', {
    staticClass: "tip-close",
    on: {
      "click": _vm.hidePlugintips
    }
  }, [_vm._v("x")])]) : _vm._e()]) : _c('div', [_c('Menu', {
    staticStyle: {
      "background": "transparent"
    },
    attrs: {
      "active-name": _vm.mactived,
      "theme": "light",
      "open-names": _vm.activedMenu,
      "accordion": true
    },
    on: {
      "on-select": _vm.fnSwitch,
      "on-open-change": _vm.openChange
    }
  }, [_vm._l((_vm.menus), function(menu, idx) {
    return [(menu.children.length) ? _c('Submenu', {
      attrs: {
        "name": ("super-m" + idx)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: menu.icon
    }), _vm._v(_vm._s(menu.title) + "\n\t\t\t    ")]), _vm._v(" "), _vm._l((menu.children), function(submenu, subidx) {
      return _c('MenuItem', {
        key: subidx,
        attrs: {
          "name": submenu._src
        }
      }, [_vm._v("\n\t\t\t    \t" + _vm._s(submenu.title) + "\n\t\t\t\t")])
    })], 2) : _c('MenuItem', {
      attrs: {
        "name": menu._src
      }
    }, [_c('i', {
      class: menu.icon
    }), _vm._v(_vm._s(menu.title) + "\n\t        ")])]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-9cbbcbba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 194
// module chunks = 2